import { SliderModal, TabSwitch, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { Header } from './components/Header';
import { RedeemTabsProvider } from './contexts/RedeemTabsContext';
import { useRedeemBatchTicketHeader } from './hooks/header';
import { useRedeemTabs } from './hooks/tabs';

interface RedeemBatchTicketProps {}

export const RedeemBatchTicket: React.FC<RedeemBatchTicketProps> = () => {
  const { handleGoBack, sliderWidth } = useRedeemBatchTicketHeader();
  const tabSwitchProps = useRedeemTabs();

  return (
    <SliderModal dismissWhenClickOutside onDismiss={handleGoBack} width={sliderWidth}>
      <RedeemTabsProvider {...tabSwitchProps}>
        <VStack flex={1} p={Spacing['stack.xxs']} space={Spacing['inline.xxxs']}>
          <Header />
          <TabSwitch {...tabSwitchProps} />
        </VStack>
      </RedeemTabsProvider>
    </SliderModal>
  );
};
